import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    padding: '2.4rem 4rem',
    alignItems: 'center',
    marginBottom: '4rem',
    [breakpoints.md.down]: {
      padding: '1.4rem 2rem',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem',
    },
  },
  proposalInfoList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[700],
    letterSpacing: '0.02rem',
    [breakpoints.md.down]: {
      margin: '0 0 1.5rem',
    },
  },
  infoKey: { fontWeight: 700, marginRight: '0.5rem' },
  actionsSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    gap: '1.6rem',
    [breakpoints.md.down]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '1rem',
      '& > button': {
        paddingLeft: 0,
      },
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
